import * as React from "react";
import { Link } from "components/common";
import usePluginEntities from "hooks/usePluginEntities";
import { useGetEntityRoute } from "routing/hooks/useShowRouteForEntity";
import ExternalLink from "components/common/ExternalLink";
import useRightSidebar from "hooks/useRightSidebar";
import resolveGraylogUri from "./resolveGraylogUri";
const GRAYLOG_URI_PREFIX = "graylog:///";
const useResolvedGraylogLink = (href) => {
  const resolvers = usePluginEntities("markdown.entityLinkResolvers");
  const getEntityRoute = useGetEntityRoute();
  if (!href.startsWith(GRAYLOG_URI_PREFIX)) {
    return null;
  }
  const resolved = resolveGraylogUri(href, resolvers);
  if (!resolved) {
    return null;
  }
  if ("onClick" in resolved) {
    return { onClick: resolved.onClick };
  }
  return { to: getEntityRoute(resolved.id, resolved.grnType) };
};
const OnClickLink = ({
  href,
  handler,
  children
}) => {
  const { openSidebar } = useRightSidebar();
  return /* @__PURE__ */ React.createElement(
    "a",
    {
      href,
      onClick: (event) => {
        event.preventDefault();
        handler({ openSidebar });
      }
    },
    children
  );
};
const MarkdownLink = ({ href, children = null }) => {
  const resolved = useResolvedGraylogLink(href);
  if (resolved && "to" in resolved) {
    return /* @__PURE__ */ React.createElement(Link, { to: resolved.to }, children);
  }
  if (resolved && "onClick" in resolved) {
    return /* @__PURE__ */ React.createElement(OnClickLink, { href, handler: resolved.onClick }, children);
  }
  return /* @__PURE__ */ React.createElement(ExternalLink, { href }, children);
};
export default MarkdownLink;
